import styles from './create-email.module.scss';
import { useState } from 'react';
import { Box, Container, Froala, Icon, Link, PrimaryButton, TextField } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../page-title/page-title';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../requestUtils';
import { GetCurrentCompany } from '@frontend-workspace/webkua-lib';

/* eslint-disable-next-line */
export interface CreateEmailProps { }

export function CreateEmail(props: CreateEmailProps) {
  const currentCompany = GetCurrentCompany();
  const companyNumber = currentCompany ? currentCompany.number : "";
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const navigate = useNavigate();
  const [htmlContent, setHtmlContent] = useState<string | undefined>("");
  const [name, setName] = useState<string | undefined>("");
  const [subject, setSubject] = useState<string | undefined>("");

  const handleCreateEmail = () => makeRequest(`emails`, 'POST', { html: htmlContent, name, subject })
    .then((emailId) => {
      const currentUrl = window.location.href;
      const newUrl = currentUrl.replace('new', emailId);
      const relativeUrl = new URL(newUrl).pathname;
      navigate(relativeUrl);
    });

  const handleBackNavigation = () => navigate(`/other/${companyNumber}/email`);

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <Link onClick={handleBackNavigation} className='d-inline-flex mb-3' underline='hover'>
              <Icon className='me-1'>arrow_back</Icon>{t('app.emails')}
            </Link>
            <PageTitle title={t('app.emails')} subtitle={`(${t('standard.newEmail')})`} />
            <Row className='mb-3'>
              <Col lg={6} xxl={4}>
                <TextField
                  value={subject}
                  onChange={(event: any) => setSubject(event.target.value)}
                  label={t('standard.emailSubject')}
                  name='subject'
                  fullWidth
                />
              </Col>
              <Col lg={6} xxl={4}>
                <TextField
                  value={name}
                  onChange={(event: any) => setName(event.target.value)}
                  label={t('createEmail.emailInternalName')}
                  name='name'
                  fullWidth
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={12} xxl={8}>
                <Froala
                  maxHeight={1600}
                  model={htmlContent}
                  onModelChanged={setHtmlContent}
                />
              </Col>
            </Row>
            <div className="d-flex justify-content-start">
              <PrimaryButton
                variant='contained'
                onClick={handleCreateEmail}
                className='minButtonWidth'>
                {t('createEmail.createEmail')}
              </PrimaryButton>
            </div>
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default CreateEmail;